import { useMutation } from "@tanstack/react-query";
import useApi from "./useApi";
import { ICD10CodeId, PatientContractId } from "../schema/schema";
import { LocalDate } from "@js-joda/core";

export function useCreateBulkDiagnosisCodesForPatientMutation(params: {
  startDate: LocalDate;
  endDate: LocalDate;
  patientContractId: PatientContractId;
}) {
  const { api } = useApi();
  return useMutation({
    mutationFn: async (icdCodes: ICD10CodeId[]) => {
      return api.post("./patient_contract_diagnosis_codes/bulk", {
        body: {
          patientContractId: params.patientContractId,
          codes: icdCodes.map((code) => ({
            endDate: params.endDate,
            startDate: params.startDate,
            icdCode: code,
            isForBilling: true,
            type: "PRINCIPAL",
          })),
        },
      });
    },
  });
}
